import React from "react";
import {RegisterValue} from "../../fstn/register";
import {ProjectDetails} from "../../redux/types/firebase";
import {ParameterDescription} from "../../fstn/action";
import SelectMarshalStorage from "./SelectMarshalStorage";
import { Box } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

interface Props {
    folder: string
    name: string
    onChangeValue: (key: string, value: RegisterValue | undefined) => void
    parameter: ParameterDescription
    projectDetails: ProjectDetails
    source: string
    value: RegisterValue
}

const useStyles = makeStyles(theme => ({
    image: {
        backgroundImage: (props: {source: string}) =>
            `url(${props.source})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        height: 100
    },
}));

export default function SelectMarshalImage({folder, name, onChangeValue, parameter, source, projectDetails, value}: Props) {
    const classes = useStyles({source: `${projectDetails.imageSource}/${folder}/${value}`});

    return (
        <SelectMarshalStorage
            name={name} onChangeValue={onChangeValue} parameter={parameter} source={source} value={value as string}
            upload="image/*">
            <Box display="flex" flexDirection="column">
                <Box flexGrow={1} className={classes.image}/>
            </Box>
        </SelectMarshalStorage>
    );
}